import React from 'react';
import { connect } from 'react-redux';
import {Modal, Row, Col, Spin, Form, Button, InputNumber, message} from 'antd';

import { Select, Input } from 'antd';
import { actions, updateTargetVersion, asyncGet,updateAllTargetVersion } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;

class EditVersion extends React.Component {
    handleCancel = () => {
    /*    this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }

                await this.props.updateAllTargetVersion(formatFormData(values));
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.getTransferData({ selectedRowKeys: [] });
                this.props.asyncGet();
            }
        });*/
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.getTransferData({ selectedRowKeys: [] });
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                const { selectedRowKeys = [] } =this.props.transferData;

                if (!selectedRowKeys.length) {
                    message.error('请选择目标客户端');
                    return null;
                }

                values.clientIdList = selectedRowKeys;

                await this.props.updateTargetVersion(formatFormData(values));
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.getTransferData({ selectedRowKeys: [] });
                this.props.asyncGet();
            }
        });
    };
    handleAllOk = () =>{
            this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                await this.props.updateAllTargetVersion(formatFormData(values));
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.getTransferData({ selectedRowKeys: [] });
                this.props.asyncGet();
            }
        });
    }
    render() {
        const { isModalShow, udpateVersionShow, item ,isUpdateVersionLoading} = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="目标版本号">
                            {getFieldDecorator('targetVersion', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入目标版本号',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                        <FormItem    {...formItemLayout}   label="更新设备类型">
                            {getFieldDecorator('deviceType', {
                                initialValue: '',
                                rules: [{ required: false, message: '请选择类型' }],
                            })(
                                <Select>
                                    <Option value="android">andorid</Option>
                                    <Option value="ios">ios</Option>
                                </Select>
                                )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
        return (
            <span>
                <Modal
                    width={800}
                    title="更新目标版本号"
                    visible={udpateVersionShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isUpdateVersionLoading}
                    maskClosable={true}
                    closable = {false}
                    footer={[
                        <Button key="取消" onClick={this.handleCancel}>取消</Button>,
                        <Button key="更新选中" type="primary"  onClick={this.handleOk}>
                           更新选中
                        </Button>,
                        <Button key="更新全部" type="danger" onClick={this.handleAllOk}>
                            更新全部
                        </Button>,
                    ]}
                >
                    <Spin spinning={isUpdateVersionLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.clientList.list.reduce((a, b) => (b.clientId === state.clientList.currentSelectId ? b : a), {}),
    isUpdateVersionLoading: state.clientList.uiStatus.isUpdateVersionLoading,
    udpateVersionShow: state.clientList.uiStatus.udpateVersionShow,
    transferData: state.clientList.transferData,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ udpateVersionShow: false })),
    updateTargetVersion: contents => dispatch(updateTargetVersion(contents)),
    asyncGet: () => dispatch(asyncGet()),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    updateAllTargetVersion: contents => dispatch(updateAllTargetVersion(contents)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(EditVersion));



// WEBPACK FOOTER //
// ./pages/client/clientList/editVersion.js